import{jsx as s}from"react/jsx-runtime";import o from"./styles.module.scss.js";const e=({counryCode:e,className:a,...m})=>s("div",{className:[o.flag,o[e],a].join(" "),...m});export{e as default};
